/* global StripeCheckout */
import React, { Component } from "react";
import Link from "react-router/Link";
import { Card, CardHeader, CardText } from "material-ui/Card";
import Dialog from "material-ui/Dialog";
import TextField from "material-ui/TextField";
import FlatButton from "material-ui/FlatButton";
import CircularProgress from "material-ui/CircularProgress";
import Done from "material-ui/svg-icons/action/done";

import {
  getPlan,
  getSubscriptions,
  getInvoices,
  createSubscription,
  resumeSubscription,
  cancelSubscription,
  updateCreditCard,
  claimCoupon
} from "../actions/actions";

import apiErrors from "../modules/apierrors";
import getErrors from "../modules/geterrors";

import "./AccountSubscription.css";

class AccountSubscription extends Component {
  constructor(props) {
    super(props);

    this.state = {
      coupon: null,
      infoDialogOpen: false,
      type: null,
      stripeLoaded: false
    };
  }

  handler = null;
  updatedHandler = null;

  componentWillMount() {
    this.props.dispatch(getPlan());

    this.props.dispatch(getSubscriptions());
    this.props.dispatch(getInvoices());

    if (typeof StripeCheckout === "undefined") {
      this.setState({ stripeLoaded: false });
    } else {
      this.setState({ stripeLoaded: true });
      //The state of the state will be updated in one batch *after* this function,
      // so stripeLoaded cannot be used inside it to check if the configuration can be run.
      // Easiest solution is this, putting it all inside one control flow.
      this.handler = StripeCheckout.configure({
        key: "pk_live_6LlznC5Y0ufn2B1gHP8oQRWT",
        image: "/images/stripe-logo-red.png",
        locale: "auto",
        zipCode: true,
        currency: "EUR",
        panelLabel: "Subscribe for {{amount}}",
        email: this.props.auth.user.email,
        allowRememberMe: false,
        token: token => {
          if (this.props.subscriptions.hasFetchedPlan) {
            token.localPlanId = this.props.subscriptions.plan.id;
            this.props.dispatch(createSubscription(token));
          }
        }
      });

      this.updateHandler = StripeCheckout.configure({
        key: "pk_live_6LlznC5Y0ufn2B1gHP8oQRWT",
        image: "/images/stripe-logo-red.png",
        locale: "auto",
        zipCode: true,
        panelLabel: "Update credit card",
        email: this.props.auth.user.email,
        allowRememberMe: false,
        token: token => {
          console.log("updating card");
          console.log(token);
          this.props.dispatch(updateCreditCard(token));
        }
      });
    }
  }

  componentWillUpdate(nextProps) {
    console.log(this.props);
    console.log(nextProps);
    if (
      this.props.subscriptions.isCreatingSubscription &&
      !nextProps.subscriptions.isCreatingSubscription &&
      nextProps.subscriptions.didSucceed
    ) {
      this.openDialog("create-subscription-success");
    } else if (
      this.props.subscriptions.isCreatingSubscription &&
      !nextProps.subscriptions.isCreatingSubscription &&
      !nextProps.subscriptions.didSucceed &&
      nextProps.subscriptions.errors.length > 0
    ) {
      this.openDialog("create-subscription-failure");
    }

    if (
      this.props.subscriptions.isCancellingSubscription &&
      !nextProps.subscriptions.isCancellingSubscription &&
      nextProps.subscriptions.errors.length === 0
    ) {
      this.openDialog("cancel-subscription-success");
    } else if (
      this.props.subscriptions.isCancellingSubscription &&
      !nextProps.subscriptions.isCancellingSubscription &&
      nextProps.subscriptions.errors.length > 0
    ) {
      this.openDialog("cancel-subscription-failure");
    }

    /*
    if (this.props.subscriptions.isResumingSubscription && !nextProps.subscriptions.isResumingSubscription && nextProps.subscriptions.errors.length === 0) {
      this.openDialog('resume-subscription-success');
    } else if (this.props.subscriptions.isResumingSubscription && !nextProps.subscriptions.isResumingSubscription && nextProps.subscriptions.errors.length > 0) {
      this.openDialog('resume-subscription-failure');
    } */
  }

  componentWillUnmount() {
    if (this.state.stripeLoaded) {
      this.handler.close();
      this.updateHandler.close();
    }
  }

  handleCoupon = () => this.setState({ coupon: this.couponInput.getValue() });

  claimCoupon = () => {
    if (this.state.coupon === null) {
      return;
    }

    this.props.dispatch(claimCoupon(this.state.coupon));
  };

  openDialog = type => {
    console.log("open dialog");
    this.setState({
      infoDialogOpen: true,
      type
    });
  };

  closeDialog = () => {
    this.setState({
      infoDialogOpen: false,
      type: null
    });
  };

  cancelSubscription() {
    this.props.dispatch(cancelSubscription());
  }

  showSubscriptionForm = () => {
    if (this.props.subscriptions.hasFetchedPlan) {
      const plan = this.props.subscriptions.plan;

      console.log("show sub form");
      this.handler.open({
        name: "Pronounce Live",
        description: "Six month subscription to Pronounce Live",
        billingAddress: true,
        amount: plan.price,
        currency: plan.currency,
        panelLabel: "Subscribe for {{amount}}"
      });
    }
  };

  showUpdateCreditCardForm = () => {
    console.log("show cc form");
    this.updateHandler.open({
      name: "Pronounce Live",
      description: "Update your credit card details.",
      billingAddress: true
    });
  };

  resumeSubscription = () => {
    //this.props.dispatch(resumeSubscription());
  };

  renderInvoiceRow = (invoice, index) => (
    <div key={`invoice-${index}`}>
      <strong>{invoice.date}</strong> {invoice.total / 100} {invoice.currency}{" "}
      {invoice.total === 0 && (
        <span>
          (This marks the beginning of your subscription during your trial
          period)
        </span>
      )}
    </div>
  );

  renderDialog = () => {
    if (!this.state.infoDialogOpen || this.state.type === null) {
      return <span key="emptydialog"></span>;
    }

    let actions;
    let title;
    let text;

    const okButton = (
      <FlatButton
        label="OK"
        primary={true}
        keyboardFocused={true}
        onTouchTap={() => this.closeDialog()}
      />
    );

    if (this.state.type === "resume") {
      actions = [
        <FlatButton
          label="No, close this window"
          primary={true}
          keyboardFocused={true}
          onTouchTap={() => this.closeDialog()}
        />,
        <FlatButton
          label="Yes, Resume Subscription"
          primary={true}
          onTouchTap={() => {
            this.resumeSubscription();
            this.closeDialog();
          }}
        />
      ];

      title = "Do you want to resume your subscription?";
      text =
        "Resuming will continue your subscription when the next billing period begins, and your card will be charged then.";
    }

    if (this.state.type === "cancel") {
      actions = [
        <FlatButton
          label="No, close this window"
          primary={true}
          keyboardFocused={true}
          onTouchTap={() => this.closeDialog()}
        />,
        <FlatButton
          label="Yes, Cancel Subscription"
          primary={true}
          onTouchTap={() => {
            this.cancelSubscription();
            this.closeDialog();
          }}
        />
      ];

      title = "Do you want to cancel your subscription?";
      text =
        "Cancelling your subscription means that you will not be charged when the next billing period begins. You can still use Pronounce Live until the end of this billing period.";
    }

    if (this.state.type === "create-subscription-success") {
      actions = [okButton];
      title = "Subscription started!";
      text = (
        <span>
          Success! You now have a Pronouce Live subscription for the next six
          months. The subscription will be automatically renewed unless you
          cancel before that. Hope you have fun with Pronounce Live! You can
          access Pronounce Live by clicking on the wave icon on the upper left,
          or by <Link to="/">clicking here</Link>.
        </span>
      );
    }

    if (this.state.type === "create-subscription-failure") {
      actions = [okButton];
      title = "Could not create a subscription :(";
      text =
        "Unfortunately our server could not create a new subscription. Please try again in a moment.";
    }

    if (this.state.type === "cancel-subscription-success") {
      actions = [okButton];
      title = "Subscription canceled";
      text =
        "Your subscription to Pronounce Live has been cancelled. You can still use Pronounce Live until the end of this billing period. We hope you will enjoy the remainder of your subscription.";
    }

    if (this.state.type === "cancel-subscription-failure") {
      actions = [okButton];
      title = "Could not cancel a subscription :(";
      text =
        "Unfortunately our server could not cancel your subscription. Please try again in a moment or contact our support.";
    }

    if (this.state.type === "resume-subscription-success") {
      actions = [okButton];
      title = "Subscription resumed!";
      text =
        "Your subscription to Pronounce Live has been resumed! Your subscription will continue automatically at the end of this billing period.";
    }

    if (this.state.type === "resume-subscription-failure") {
      actions = [okButton];
      title = "Could not resume your subscription :(";
      text =
        "Unfortunately our server could not resume your subscription. Please try again in a moment or contact our support.";
    }

    return (
      <Dialog
        title={title}
        actions={actions}
        modal={false}
        open={this.state.infoDialogOpen}
        onTouchTap={() => this.setState({ infoDialogOpen: false, type: "" })}
      >
        {text}
      </Dialog>
    );
  };

  render() {
    const { auth, subscriptions, invoices } = this.props;

    if (!this.props.auth.isAuthenticated) {
      return <span />;
    }

    const {
      errorMessages,
      validationErrors,
      stripeErrors,
      stripeConnectionErrors
    } = getErrors(subscriptions.errors);
    console.log(stripeErrors);

    const disabled =
      this.state.stripeLoaded === false ||
      !subscriptions.hasFetchedPlan ||
      subscriptions.isFetching;

    let busyLabel = "";

    if (subscriptions.isFetching) {
      if (subscriptions.isCreatingSubscription) {
        busyLabel = "Creating your subscription";
      }

      if (subscriptions.isCancellingSubscription) {
        busyLabel = "Cancelling your subscription";
      }

      if (subscriptions.isResumingSubscription) {
        busyLabel = "Resuming your subscription";
      }

      if (subscriptions.isUpdatingCard) {
        busyLabel = "Updating your card";
      }
    }

    let subscriptionInfo = "";
    let subscriptionBtnLabel = "Fetching plan...";

    const symbols = {
      EUR: "€",
      USD: "$",
      GBP: "£"
    };

    if (this.props.subscriptions.hasFetchedPlan) {
      const price = this.props.subscriptions.plan.price / 100;
      const curSymbol = symbols[this.props.subscriptions.plan.currency];
      subscriptionInfo = `Subscription available for 6 months / ${price} ${curSymbol}.`;
      subscriptionBtnLabel = `Get 6 months for ${price} ${curSymbol}`;
    }

    const btnStyle = {
      color: "#fff"
    };

    return (
      <div className="subscription-wrapper">
        <Card className="card-wide">
          <CardHeader title="Subscription" />
          <CardText>
            {errorMessages.length > 0 && (
              <div className="pronounce-error error-form">
                {errorMessages.map((error, index) => (
                  <div key={index}>
                    <strong>{error}</strong>
                  </div>
                ))}
              </div>
            )}

            {stripeErrors.length > 0 && (
              <div className="pronounce-error error-form">
                <p>
                  There was an error with our payment processor. Please try
                  again in a moment. Administration has been notified.
                </p>
                {errorMessages.map((error, index) => (
                  <div key={index}>
                    <strong>{error}</strong>
                  </div>
                ))}
              </div>
            )}

            {stripeConnectionErrors.length > 0 && (
              <div className="pronounce-error error-form">
                <p>
                  There was an error connecting to our payment processor. Please
                  try again in a moment. Administration has been notified.
                </p>
                {errorMessages.map((error, index) => (
                  <div key={index}>
                    <strong>{error}</strong>
                  </div>
                ))}
              </div>
            )}

            <div className="subscription-info">
              <p>
                If you have any questions or issues with your trial or
                subscriptions, please{" "}
                <a
                  target="_blank"
                  href="http://www.sanako.com/help/pronounce-live-faq/"
                >
                  check our FAQ
                </a>
                .
              </p>
            </div>
            {subscriptions.info.subscribed && !subscriptions.info.cancelled && (
              <div>
                <p>
                  <Done /> <strong>Your subscription is active!</strong>
                </p>

                {!subscriptions.info.onTrial &&
                  subscriptions.info.billingCycleStart && (
                    <div>
                      <p>
                        Your current billing period started{" "}
                        <strong>{subscriptions.info.billingCycleStart}</strong>.
                      </p>
                      <p>
                        It will end on{" "}
                        <strong>{subscriptions.info.billingCycleEnd}</strong>.
                      </p>
                      <p>
                        Your subscription will be automatically cancelled when
                        this billing cycle ends.{" "}
                      </p>
                      <p>
                        You can still use Pronounce Live until the end of this
                        billing period.
                      </p>
                    </div>
                  )}

                {!subscriptions.info.onTrial &&
                  !subscriptions.info.billingCycleStart && (
                    <div>
                      <p>
                        Your subscription will be automatically cancelled when
                        this billing cycle ends.{" "}
                      </p>
                      <p>
                        You can still use Pronounce Live until the end of this
                        billing period.
                      </p>
                    </div>
                  )}

                {subscriptions.info.onTrial && auth.user.hasActiveSubscription && (
                  <div>
                    <p>
                      You are still on your trial period until{" "}
                      <strong>{subscriptions.info.trialEndsAt}</strong> (
                      {subscriptions.info.untilTrialEnds}).
                    </p>
                    <p>
                      This means your actual subscription will begin then. You
                      can cancel before that and your credit card will not be
                      charged.
                    </p>
                  </div>
                )}

                <FlatButton
                  backgroundColor="rgb(49, 192, 76)"
                  style={btnStyle}
                  disabled={disabled}
                  onTouchTap={() => this.openDialog("cancel")}
                  type="submit"
                  label="Cancel subscription"
                />
              </div>
            )}

            {subscriptions.info.onGracePeriod && !subscriptions.info.onTrial && (
              <div>
                <p>
                  <strong>You have cancelled your subscription.</strong>
                </p>
                <p>
                  You can still use Pronounce until the remainder of this
                  billing period, whichs ends on{" "}
                  <strong>{subscriptions.info.billingCycleEnd}</strong>.
                </p>
                <FlatButton
                  backgroundColor="rgb(49, 192, 76)"
                  style={btnStyle}
                  disabled={disabled}
                  onTouchTap={() => this.openDialog("resume")}
                  label="Resume your subscription"
                />
              </div>
            )}

            {subscriptions.info.onGracePeriod && subscriptions.info.onTrial && (
              <div>
                <p>
                  <strong>You have cancelled your subscription.</strong>
                </p>
                <p>
                  You can still use Pronounce until the remainder of your trial
                  period, which ends{" "}
                  <strong>{subscriptions.info.trialEndsAt}</strong> (
                  {subscriptions.info.untilTrialEnds}).
                </p>
                <p>
                  If you resume your subscription, it will be charged
                  automatically after your trial period ends, and you can
                  continue to use Pronounce Live seamlessly.
                </p>
                <FlatButton
                  backgroundColor="rgb(49, 192, 76)"
                  style={btnStyle}
                  disabled={disabled}
                  onTouchTap={() => this.openDialog("resume")}
                  label="Resume your subscription"
                />
              </div>
            )}

            {subscriptions.hasFetched &&
              !auth.user.hasActiveSubscription &&
              !subscriptions.info.onGenericTrial && (
                <div>
                  <p>
                    <strong>
                      Your subscription is not currently active. You do not have
                      access to Pronounce Live at the moment.
                    </strong>
                  </p>
                  {/* <p>Click below to start a new subscription.</p>
                <p>{subscriptionInfo}</p>

                { auth.user.hasGroup && !auth.user.hasActiveGroup && (
                  <p>(If you subscribe, your membership to {auth.user.group.name} will be removed)</p>
                )}
                <FlatButton backgroundColor="rgb(49, 192, 76)" style={btnStyle} disabled={disabled} onTouchTap={ () => this.showSubscriptionForm() } label={subscriptionBtnLabel} />*/}
                </div>
              )}

            {subscriptions.isFetching && (
              <div className="account-success-overlay">
                <CircularProgress /> {busyLabel}...
              </div>
            )}

            {(!subscriptions.info.subscribed ||
              (subscriptions.info.cancelled &&
                !subscriptions.info.onGracePeriod)) &&
              subscriptions.info.onGenericTrial && (
                <div>
                  <p>
                    You are on your trial period which ends{" "}
                    <strong>{subscriptions.info.trialEndsAt}</strong> (
                    {subscriptions.info.untilTrialEnds}).
                  </p>
                  <p>
                    To use Pronounce Live after that you need a subscription.
                  </p>
                  <p>
                    {subscriptionInfo} Your subscription will start when the
                    trial ends, and you can cancel your subscription at anytime
                    before that.
                  </p>
                  <FlatButton
                    backgroundColor="rgb(49, 192, 76)"
                    style={btnStyle}
                    disabled={disabled}
                    onTouchTap={() => this.showSubscriptionForm()}
                    label={subscriptionBtnLabel}
                  />
                </div>
              )}

            {!this.state.stripeLoaded && (
              <p>
                <strong>
                  Unfortunately our payment processor server is unreachable at
                  the moment, so account activities like subscribing and
                  updating your card are suspended at the moment. We are very
                  sorry - please try again in a moment.
                </strong>
              </p>
            )}
          </CardText>
        </Card>
        {subscriptions.info.subscribed && (
          <Card className="card-wide">
            <CardHeader title="Stored payment method" />
            <CardText>
              {subscriptions.hasFetched && subscriptions.info.card.brand && (
                <div>
                  <p>
                    Your current card on file is a{" "}
                    <strong>{subscriptions.info.card.brand}</strong> ending in{" "}
                    <strong>{subscriptions.info.card.last_four}</strong>.
                  </p>
                  <p>Please keep your card information up to date.</p>
                </div>
              )}
              <FlatButton
                backgroundColor="rgb(49, 192, 76)"
                style={btnStyle}
                disabled={disabled}
                onTouchTap={() => this.showUpdateCreditCardForm()}
                label="Update Credit Card"
              />
            </CardText>
          </Card>
        )}

        <Card className="card-wide">
          <CardHeader title="Payment history" />
          <CardText>
            {invoices.invoices.map((invoice, index) =>
              this.renderInvoiceRow(invoice, index)
            )}
            {invoices.invoices.length === 0 && (
              <p>You do not have any invoices yet.</p>
            )}
          </CardText>
        </Card>

        <Card className="card-wide">
          <CardHeader title="Subscription event history" />
          <CardText></CardText>
        </Card>
        {this.renderDialog()}
      </div>
    );
  }
}

export default AccountSubscription;



// WEBPACK FOOTER //
// ./src/components/AccountSubscription.js